export default __webpack_public_path__ + "static/media/logo-with-tagline.ddf41caa.png";